export default __webpack_public_path__ + "static/media/preview—android-left.149d540f.png";